<template>
    <div class="widget widget-product card" v-if="promoSectionProduct != '' && promoSectionProduct[sectionNumber] != null">
        <header class="card-header">
            <h3 class="card-title">
                <span>{{   promoSectionProduct[sectionNumber].Title  }}</span>
                <span style="">
                    <router-link to="/filter" class="d-block d-sm-none">
                        <i class="fa fa-external-link btn-link-m" aria-hidden="true"></i>
                    </router-link>
                </span>
            </h3>
            <!--<a href="#" class="view-all">مشاهده همه</a>-->
        </header>
        <div class="product-carousel owl-carousel owl-theme">
            <div style="position:relative" class="item  discount-box" v-for="(product,index) in promoSectionProduct[sectionNumber].PromProducts">
                <div :class="!product.IsAvailable ? 'filter' : '' ">
                    <span class="discount" v-if="product.DiscountPercent != 0  && product.Price != 0 && product.IsAvailable">{{product.DiscountPercent}} %</span>
                    <router-link :title="product.Name" :to="{ name: 'product' , params: { productId: product.Id , productName: product.Name.replace(/\s+/g, '-') } }">
                        <img :src="product.PicPath" class="img-fluid" :alt="product.Name.replace(/\s+/g, '-')" :title="product.Name.replace(/\s+/g, '-')" @error="imageLoadOnError">
                    </router-link>
                    <h2 class="post-title">
                        <router-link tag="a" :title="product.Name" :to="{ name: 'product' , params: { productId: product.Id , productName: product.Name.replace(/\s+/g, '-') } }">{{ product.Name }}</router-link>
                    </h2>
                    <div v-if="!isUserLogined && product.IsShowPriceInWeb">
                        <div class="price" v-if="product.Price != 0 && product.IsPossibilityBuyProduct">
                            <div class="flex-price" v-if="product.IsAvailable">
                                <div class="text-center" v-if="product.DiscountPercent != 0">
                                    <del><span>{{ product.Price | formatNumber }}<span> ریال </span></span></del>
                                </div>
                                <div class="text-center">
                                    <ins><span>{{ product.FinalPrice | formatNumber }}<span> ریال </span></span></ins>
                                </div>
                            </div>
                            <div v-else>
                                <div> <span class="unAvailable"> اتمام موجودی </span> </div>
                            </div>
                            <!-- اتمام موجودی -->
                        </div>
                        <div v-if="product.Price == 0 && product.IsPossibilityBuyProduct">
                            <div class="callToMain">
                                <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                            </div>
                        </div>
                        <div class="wi-div-in" v-if="product.IsPossibilityBuyProduct">
                            <i v-if="product.IsAvailable && product.Price != 0" @click="AddItemWithProductId(product.Id)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                        </div>
                    </div>

                    <div v-if="isUserLogined && customerGroupId != 2">
                        <div class="price" v-if="product.Price != 0 && product.IsPossibilityBuyProduct">
                            <div class="flex-price" v-if="product.IsAvailable">
                                <div class="text-center" v-if="product.DiscountPercent != 0">
                                    <del><span>{{ product.Price | formatNumber }}<span> ریال </span></span></del>
                                </div>
                                <div class="text-center">
                                    <ins><span>{{ product.FinalPrice | formatNumber }}<span> ریال </span></span></ins>
                                </div>
                            </div>
                            <div v-else>
                                <div> <span class="unAvailable"> اتمام موجودی </span> </div>
                            </div>
                            <!-- اتمام موجودی -->
                        </div>
                        <div v-if="product.Price == 0 && product.IsPossibilityBuyProduct">
                            <div class="callToMain">
                                <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                            </div>
                        </div>
                        <div class="wi-div-in" v-if="product.IsPossibilityBuyProduct">
                            <i v-if="product.IsAvailable && product.Price != 0" @click="AddItemWithProductId(product.Id)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                        </div>
                    </div>

                    <div v-if="isUserLogined && customerGroupId == 2">
                        <div class="price" v-if="product.Price != 0 && product.IsPossibilityBuyProduct">
                            <div class="flex-price" v-if="product.IsAvailable">
                                <div class="text-center" v-if="product.DiscountPercent != 0">
                                    <del><span>{{ product.Price | formatNumber }}<span> ریال </span></span></del>
                                </div>
                                <div class="text-center">
                                    <ins><span>{{ product.FinalPrice | formatNumber }}<span> ریال </span></span></ins>
                                </div>
                            </div>
                            <div v-else>
                                <div> <span class="unAvailable"> اتمام موجودی </span> </div>
                            </div>
                            <!-- اتمام موجودی -->
                        </div>
                        <div v-if="product.Price == 0 && product.IsPossibilityBuyProduct">
                            <div class="callToMain">
                                <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                            </div>
                        </div>
                        <div class="wi-div-in" v-if="product.IsPossibilityBuyProduct">
                            <i v-if="product.IsAvailable && product.Price != 0" @click="AddItemWithProductId(product.Id)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="d-none d-sm-block">
            <div class="row">
                <div class="col-md-12">
                    <div class="btnMore-new">
                        <router-link to="/filter">نمایش کامل</router-link>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { setCart } from "../../module/cart";
    export default {

        props: ["sectionNumber"],
        computed: {
            promoSectionProduct() {
                return this.$store.getters.readPromoSectionProducts;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            } 
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            AddItemWithProductId(productId) {
                setCart(this, productId, 'AddItemWithProductId', '.loader', null, 1);
            },
        }

    }
</script>

<style scoped>
    .btnMore-new {
        border-top: 1px solid #ddd;
        text-align: center;
    }

        .btnMore-new a {
            display: inline-block;
            padding: 10px;
            font-size: 14px;
            font-weight: bold;
            color: #06d;
        }

            .btnMore-new a:hover {
                cursor: pointer;
            }

    .call {
        font-size: 13px;
    }

    .unAvailable {
        font-size: 14px;
    }

    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }

        .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }

        .widget-product .product-carousel .item ins, .brand-slider .product-carousel .item ins {
            color: #ef5661;
            font-size: 13px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 640px) {
        .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }
    }
</style>